// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.budgetCard_budgetCard__jhG4W {
  background-color: var(--white);
  border-radius: var(--border-radius-large);
  padding: 16px;
  border: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
}
.budgetCard_budgetCard__jhG4W .budgetCard_cardTitle__jqc8U {
  font: var(--body-font-one);
  font-weight: 600;
  text-transform: capitalize;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/budget-card/budgetCard.module.scss"],"names":[],"mappings":"AAAA;EACI,8BAAA;EACA,yCAAA;EACA,aAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AACJ;AACI;EACI,0BAAA;EACA,gBAAA;EACA,0BAAA;AACR","sourcesContent":[".budgetCard {\r\n    background-color: var(--white);\r\n    border-radius: var(--border-radius-large);\r\n    padding: 16px;\r\n    border: 1px solid var(--border);\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 16px;\r\n    height: 100%;\r\n\r\n    .cardTitle {\r\n        font: var(--body-font-one);\r\n        font-weight: 600;\r\n        text-transform: capitalize;\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"budgetCard": `budgetCard_budgetCard__jhG4W`,
	"cardTitle": `budgetCard_cardTitle__jqc8U`
};
export default ___CSS_LOADER_EXPORT___;
